import { render, staticRenderFns } from "./KebijakanPrivasi.vue?vue&type=template&id=90b9e9e4&scoped=true"
import script from "./KebijakanPrivasi.vue?vue&type=script&lang=js"
export * from "./KebijakanPrivasi.vue?vue&type=script&lang=js"
import style0 from "./KebijakanPrivasi.vue?vue&type=style&index=0&id=90b9e9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b9e9e4",
  null
  
)

export default component.exports